export default {
  title: 'HLR',

  labels: {
    search: 'Ingrese el número de teléfono',
    status: 'Estado de la búsqueda'
  }
}
